import React, { useState } from 'react'
import { useAccess } from 'contexts/access'
import { FormattedMessage } from 'react-intl'
import { Label } from './s'
import { Plain } from 'components/button'
import Modal from 'modals/dialog'
import ExportUsersContent from 'pages/people/modals/export-users'
import { DownloadCloud } from 'styled-icons/feather'

const ExportUsers = ({ salt }) => {
    const [exporting, setExporting] = useState(false)

    const { check } = useAccess()
    const exportAccess = check('users:export:manage')

    if(!exportAccess) {
        return null
    }

    return (
        <>
            <div>
                <Plain
                    className="constructive"
                    icon={DownloadCloud}
                    onClick={() => setExporting(true)}
                    disabled={exporting}>
                    <Label>
                        <FormattedMessage
                            id="people_action_export"
                            defaultMessage="Export users" />
                    </Label>
                </Plain>
            </div>
            <Modal
                show={exporting}
                dismiss={() => setExporting(false)}
                className="scrollable"
                salt={salt}>
                <ExportUsersContent salt={salt} />
            </Modal>
        </>
    )
}

export default ExportUsers